import axios from "axios"
import { getRestApiBaseUrl } from "../utils/restApiBaseUrl"
import { RegistrarLogErro } from "./clientefiel"

const api = axios.create({
    baseURL: getRestApiBaseUrl(),
})

api.interceptors.request.use(config => {
    try {
        config.headers.common["sistema"] = "painel"

        const windowName = window.name
        if (windowName) config.headers.common["identificador"] = windowName

        return config
    } catch (error) {
        console.log("Error API Interceptor", error)
        RegistrarLogErro(error, "API Interceptor", { config })

        return config
    }
})

export default api
